// import { useEffect, useState } from "react";
// import { api } from "../../api/api";
// import { country_url } from "../../api/urls";
// import { Controller, useForm } from "react-hook-form";
// import { TextField, InputAdornment } from "@mui/material";
// import { MobileNumberDropdown } from "../../components/MobileNumberDropdown";
// import { useDispatch } from "react-redux";
// import { handleAlphaTwoCode} from "../../Redux/Auth";
// import { motion } from "framer-motion";
// import { toast } from "react-toastify";
// import { X} from "lucide-react";
// import { password_reset_api } from "../../api/urls";
// import { setPhone } from "../../Redux/Auth";

// const headingStyle = {
//   textAlign: "center",
//   marginBottom: "20px",
//   color: "#000",
// };

// const buttonStyle = {
//   width: "100%",
//   padding: "10px",
//   backgroundColor: "#000",
//   color: "#fff",
//   border: "none",
//   borderRadius: "5px",
//   cursor: "pointer",
//   fontSize: "16px",
//   marginBottom: "10px",
// };

// const extractErrorMessage = (error) => {
//   let message = "An unexpected error occurred.";
//   if (error && error.data) {
//     message = error.data || error.data.message || message;
//   } else if (error.request) {
//     message = "No response from server. Please check your connection.";
//   } else if (error.message) {
//     message = error.message;
//   }
//   return message;
// };

// const MobileNumber = ({ setPage }) => {
//   const { control, handleSubmit, reset, watch, setValue } = useForm({
//     defaultValues: {
//       number: "",
//       password: "",
//     },
//   });
//   const [countries, setCountries] = useState([]);
//   const [selectedCountryCode, setSelectedCountryCode] = useState("");
//   const [alphaTwoCode, setAlphaTwoCode] = useState("in");
//   const [loading, setLoading] = useState(false);
//   const dispatch = useDispatch();

//   useEffect(() => {
//     const fetchCountryCodes = async () => {
//       try {
//         const { data: countryData } = await api.get(country_url);
//         setCountries(countryData);
//         if (countryData.length > 0) {
//           setSelectedCountryCode(91);
//         }
//       } catch (err) {
//         toast.error(err.message || "Failed to fetch countries");
//       }
//     };

//     fetchCountryCodes();
//   }, []);

//   useEffect(() => {
//     const unsub = watch((value) => {
//       let current = value.number;
//       if (current?.startsWith("0")) {
//         setValue("number", current.slice(1));
//       }
//     });
//     return () => unsub.unsubscribe();
//   }, [watch, setValue]);

//   const handleNext = async (data) => {
//     if (!selectedCountryCode) {
//       toast.error("Please select a valid country code.");
//       return;
//     }
//     setLoading(true);

//     try {

//       let phoneNumber = data.number;

//       if (phoneNumber.startsWith("0")) {
//         phoneNumber = phoneNumber.slice(1);
//         setValue("number", phoneNumber);
//       }
//       // const mob_num = { email: `${selectedCountryCode}${data.number}` };
//       const mob_num = { email: `${selectedCountryCode}${phoneNumber}` };

//        await api.post(password_reset_api, mob_num)
//       // dispatch(setPhone(`${selectedCountryCode}${data.number}`));

//       dispatch(setPhone(`${selectedCountryCode}${phoneNumber}`));

//       setPage(1)
//       dispatch(handleAlphaTwoCode(alphaTwoCode));

//       reset();

//     } catch (error) {
//       toast.error("mobile number not registered with tagon");
//     } finally {
//       setLoading(false);
//     }
//   }

//   return (
//     <div style={{ height: "100vh" }} className="center-content">
//       <motion.div
//         initial={{ opacity: 0, y: -20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.6 }}
//         className="auth-card"
//       >
//         <div className="xIcon">
//           <X />
//         </div>
//         <h2 style={headingStyle}>Enter Mobile Number</h2>
//         <form onSubmit={handleSubmit(handleNext)}>
//           <motion.div whileFocus={{ scale: 1.02 }} style={{ marginBottom: "15px" }}>
//             <Controller
//               name="number"

//               control={control}
//               rules={{
//                 required: "Phone number is required",
//                 pattern: {
//                   value: /^[0-9]{10,15}$/,
//                   message: "Enter a valid phone number",
//                 },
//               }}
//               render={({ field, fieldState: { error } }) => (
//                 <TextField
//                   {...field}
//                   label="Phone Number"

//                   error={!!error}
//                   helperText={error ? error.message : ""}
//                   fullWidth
//                   // autoComplete="tel"
//                   name="user_phone"               // ✅ Add this line
//                   // autoComplete="tel-local"
//                   autoComplete="tel-national"

//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <MobileNumberDropdown
//                           countryData={countries}
//                           onChange={(v) => {
//                             setAlphaTwoCode(v.alpha_two_code.toLowerCase());
//                             setSelectedCountryCode(v.country_mobile_code);
//                           }}
//                           value={selectedCountryCode}
//                         />
//                       </InputAdornment>
//                     ),
//                   }}
//                   inputProps={{

//                     autoComplete: "tel-national", // ✅ also repeat here to ensure browser honors it
//                   }}
//                 />
//               )}
//             />
//           </motion.div>

//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               marginBottom: "20px",
//               fontSize: "14px",
//             }}
//           >

//           </div>

//           <motion.button
//             type="submit"
//             disabled={loading}
//             whileTap={{ scale: 0.95 }}
//             style={buttonStyle}
//             whileHover={{ scale: 1.05 }}
//           // onClick={()=>{

//           // }}
//           >
//             {loading ? "Signing in..." : "Next"}
//           </motion.button>

//         </form>
//       </motion.div>
//     </div>
//   );
// };

// export default MobileNumber;
import { useEffect, useState } from "react";
import { api } from "../../api/api";
import { country_url } from "../../api/urls";
import { Controller, useForm } from "react-hook-form";
import { TextField, InputAdornment } from "@mui/material";
import { MobileNumberDropdown } from "../../components/MobileNumberDropdown";
import { useDispatch } from "react-redux";
import { handleAlphaTwoCode } from "../../Redux/Auth";
import { motion } from "framer-motion";
import { toast } from "react-toastify";
import { password_reset_api } from "../../api/urls";
import { setPhone } from "../../Redux/Auth";
import { getMobileNumberLengthFromRegex } from "../../utils/mobileRegexLength";

const headingStyle = {
  textAlign: "center",
  marginBottom: "20px",
  color: "#000",
};

const buttonStyle = {
  width: "100%",
  padding: "10px",
  backgroundColor: "#000",
  color: "#fff",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  fontSize: "16px",
  marginBottom: "10px",
};

const MobileNumber = ({ onClose, setPage }) => {
  const { control, handleSubmit, reset, watch, setValue } = useForm({
    defaultValues: {
      number: "",
      password: "",
    },
  });
  const [countries, setCountries] = useState([]);
  const [selectedCountryCode, setSelectedCountryCode] = useState("");
  const [alphaTwoCode, setAlphaTwoCode] = useState("in");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const selectedCountry = {
    country_mobile_code: 91,
    country_name: "India",
  };

  useEffect(() => {
    const fetchCountryCodes = async () => {
      try {
        const { data: countryData } = await api.get(country_url);
        setCountries(countryData);
        if (countryData.length > 0) {
          setSelectedCountryCode(91);
        }
      } catch (err) {
        toast.error(err.message || "Failed to fetch countries");
      }
    };

    fetchCountryCodes();
  }, []);

  useEffect(() => {
    const unsub = watch((value) => {
      const current = value.number;
      if (current?.startsWith("0")) {
        setValue("number", current.slice(1)); //  remove leading 0
      }
    });
    return () => unsub.unsubscribe();
  }, [watch, setValue]);

  useEffect(() => {
    const unsub = watch((value) => {
      let current = value.number;
      if (current?.startsWith("0")) {
        setValue("number", current.slice(1));
      }
    });
    return () => unsub.unsubscribe();
  }, [watch, setValue]);

  const handleNext = async (data) => {
    if (!selectedCountryCode) {
      toast.error("Please select a valid country code.");
      return;
    }
    setLoading(true);

    try {
      let phoneNumber = data.number;

      if (phoneNumber.startsWith("0")) {
        phoneNumber = phoneNumber.slice(1);
        setValue("number", phoneNumber);
      }
      // const mob_num = { email: `${selectedCountryCode}${data.number}` };
      const mob_num = { email: `${selectedCountryCode}${phoneNumber}` };

      await api.post(password_reset_api, mob_num);
      // dispatch(setPhone(`${selectedCountryCode}${data.number}`));

      dispatch(setPhone(`${selectedCountryCode}${phoneNumber}`));

      setPage(1);
      dispatch(handleAlphaTwoCode(alphaTwoCode));

      reset();
    } catch (error) {
      toast.error("mobile number not registered with tagon");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="auth-card"
      >
        <div className="xIcon" onClick={onClose}>
          <X />
        </div> */}
        <h2 style={headingStyle}>Enter Mobile Number</h2>
        <form onSubmit={handleSubmit(handleNext)}>
          <motion.div
            whileFocus={{ scale: 1.02 }}
            style={{ marginBottom: "15px" }}
          >
            {/* <Controller
              name="number"

              control={control}
              rules={{
                required: "Phone number is required",
                pattern: {
                  value: /^[0-9]{10,15}$/,
                  message: "Enter a valid phone number",
                },
              }}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  label="Phone Number"

                  error={!!error}
                  helperText={error ? error.message : ""}
                  fullWidth
                  // autoComplete="tel"
                  name="user_phone"               // ✅ Add this line
                  // autoComplete="tel-local"
                  autoComplete="tel-national"

                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <MobileNumberDropdown
                          countryData={countries}
                          onChange={(v) => {
                            setAlphaTwoCode(v.alpha_two_code.toLowerCase());
                            setSelectedCountryCode(v.country_mobile_code);
                          }}
                          value={selectedCountryCode}
                        />
                      </InputAdornment>
                    ),
                  }}
                  inputProps={{

                    autoComplete: "tel-national", // ✅ also repeat here to ensure browser honors it
                  }}
                />
              )}
            /> */}
            <Controller
              name="number"
              control={control}
              rules={{
                required: "Phone number is required",
              }}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  label="Phone Number"
                  fullWidth
                  name="user_phone"
                  autoComplete="tel-national"
                  error={!!error}
                  helperText={error ? error.message : ""}
                  onChange={(e) => {
                    const digitsOnly = e.target.value.replace(/\D/g, ""); // only digits allowed

                    const mobileMaxLength =
                      getMobileNumberLengthFromRegex(
                        selectedCountry?.country_regex,
                        selectedCountryCode.toString()
                      ) || 11; // ✅ dynamic max based on country

                    if (digitsOnly.length > mobileMaxLength) return;
                    field.onChange(digitsOnly);
                  }}
                  onPaste={(e) => {
                    const pasted = e.clipboardData
                      .getData("text")
                      .replace(/\D/g, "");
                    e.preventDefault();
                    field.onChange(pasted);
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <MobileNumberDropdown
                          countryData={countries}
                          value={selectedCountryCode}
                          onChange={(v) => {
                            setAlphaTwoCode(v.alpha_two_code.toLowerCase());
                            setSelectedCountryCode(v.country_mobile_code);
                            setValue("number", ""); // ✅ reset input on change
                          }}
                        />
                      </InputAdornment>
                    ),
                  }}
                  inputProps={{
                    autoComplete: "tel-national",
                  }}
                />
              )}
            />
          </motion.div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
              fontSize: "14px",
            }}
          ></div>

          <motion.button
            type="submit"
            disabled={loading}
            whileTap={{ scale: 0.95 }}
            style={buttonStyle}
            whileHover={{ scale: 1.05 }}
            // onClick={()=>{

            // }}
          >
            {loading ? "Signing in..." : "Next"}
          </motion.button>
        </form>
      {/* </motion.div> */}
    </>
  );
};

export default MobileNumber;
